<template>
    <button
        class="lp-primary-btn tw-rounded-lg tw-bg-[rgba(6,71,137,0.05)] tw-flex tw-w-[10.25rem] tw-h-[3.75rem] tw-justify-center tw-items-center tw-shrink-0 tw-border-0"
        :style="{background: getRgba(baseColor, 0.05)}"
        @click="clickCallback"
    >
         <span
                 class="tw-w-[10.25rem] tw-h-[3.75rem] tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-text-[#064789] tw-text-center tw-font-poppins tw-text-xl tw-font-bold"
                :style="{color: baseColor}"
         >
             {{ content }}
        </span>
    </button>
</template>
<script>
import rgbaSwitchMixin from "../Mixins/rgbaSwitchMixin";

export default {
    name: 'LpPrimaryButton',
    components: {},
    mixins: [rgbaSwitchMixin],
    props: {
        content: {
            type: String,
            required: true,
        },
        clickCallback: {
            type: Function,
            default: () => {},
        },
        baseColor: {
            type: String,
            required: true,
        }
    },
    data() {
        return {};
    },
    computed: {

    },
    methods: {

    },
};
</script>
